<template>
  <form class="jobForm grid-12" onsubmit="return false" @submit="send" autocomplete="off">
    <h3>Dados do Job</h3>
    <div class="row wrap column-s">
      <div class="column grid-3-g grid-6-m grid-12-s">
        <label>Cliente</label>
        <SelectFilter :list="clients" @value="escolhaCliente" :name="'nome_cliente'" :required="true" />
      </div>
      <div class="column grid-3-g grid-5-m grid-12-s">
        <label>Urgência</label>
        <select v-model="form.urgencia_atendimento" required>
          <option value>Selecione</option>
          <option value="imediato">Atendimento Imediato (Até 1 hora)</option>
          <option value="agendado">Atendimento Agendado</option>
        </select>
      </div>
      <div class="column grid-3-g grid-6-m grid-12-s" v-if="form.urgencia_atendimento === 'agendado'">
        <label>Agendamento</label>
        <div class="row grid-12">
          <input class="grid-8" type="date" v-model="form.dh_agendamento_cliente_data"
            :readonly="form.urgencia_atendimento === 'imediato'" required />
          &nbsp;
          <input style="width:100px;margin: 0 12px;" type="time" v-model="form.dh_agendamento_cliente_hora"
            :readonly="form.urgencia_atendimento === 'imediato'" required />
        </div>
      </div>
      <div class="column grid-1 grid-6-s" style="margin-right: 20px;">
        <label>Cód. Venda</label>
        <input type="text" v-model="form.codigo_venda" />
      </div>
      <div class="column grid-3 grid-6-s">
        <label>Chamado Cliente</label>
        <input type="text" v-model="form.codigo_chamado_cliente" @change="verify_client_cod()"
          :required="chamado_cliente" />
      </div>
      <div class="column grid-12 grid-6-g" v-if="form.codigo_duplicado">
        <label>Motivo código do cliente duplicado</label>
        <input type="text" v-model="form.motivo_codigo_duplicado" required />
      </div>
    </div>

    <h3>Local de atendimento</h3>
    <div class="row wrap justify-space column-s">
      <div class="row grid-12 wrap column-s justify-space">
        <div class="grid-2-g grid-6 column">
          <label>CEP <a href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank">
              (CORREIOS)</a></label>
          <input type="text" v-model="form.cep" @change="cep" v-mask="'##.###-###'" required />
        </div>
        <div class="grid-4-g grid-12 column">
          <label>Logradouro</label>
          <input type="text" :class="logradouro && 'readonly'" :readonly="logradouro" v-model="form.logradouro"
            required />
        </div>
        <div class="grid-2-g grid-12 column">
          <label>Número</label>
          <input v-model="form.numero" required />
        </div>
        <div class="grid-3-g grid-12 column">
          <label>Cidade</label>
          <input type="text" :class="cidade && 'readonly'" :readonly="cidade" v-model="form.cidade" />
        </div>
        <div class="grid-3-g grid-12 column">
          <label>Bairro</label>
          <input type="text" :class="bairro && 'readonly'" :readonly="bairro" v-model="form.bairro" />
        </div>
        <div class="grid-3-g grid-12 column">
          <label>Estado</label>
          <input type="text" :class="estado && 'readonly'" :readonly="estado" v-model="form.estado" />
        </div>
        <div class="grid-2-g grid-12 column">
          <label>Complemento</label>
          <input type="text" v-model="form.complemento" />
        </div>
        <div class="grid-3-g grid-12 column">
          <label>Nome no local de atendimento</label>
          <input type="text" v-model="form.nome_local_atendimento" required />
        </div>
      </div>
    </div>

    <h3>Dados do contato</h3>
    <div class="row grid-12 wrap column-s justify-space">
      <div class="column grid-4-g grid-12">
        <label>Nome</label>
        <input v-model="form.nome_contato" placeholder="Nome contato" />
      </div>
      <div class="column grid-4-g grid-12">
        <label>E-mail</label>
        <input v-model="form.email_contato" placeholder="E-mail contato" />
      </div>
      <div class="column grid-4-g grid-6">
        <label>Telefone</label>
        <input v-model="form.celular_contato" placeholder="Telefone contato" v-mask="'(##) #####-####'" />
      </div>
    </div>
    <h3>Descrição do problema</h3>
    <div class="row grid-12 wrap column-s">
      <div class="grid-6-g grid-12 column label">
        <br />
        <label>
          Descrição Problema
          <i class="fa fa-question-circle font-13 tip">
            <div>
              Descreva em detalhes o seu problema. Não informe aqui dados
              sensíveis.
            </div>
          </i>
        </label>
        <textarea class="textarea" v-model="form.problema" required></textarea>
      </div>
      <div class="grid-6-g grid-12 column label">
        <br />
        <label>
          Dados Sensíveis
          <i class="fa fa-question-circle font-13 tip">
            <div>
              Informe aqui dados sensíveis como contatos, endereços, senhas,
              nomes, telefones, etc.
            </div>
          </i>
        </label>
        <textarea class="textarea" v-model="form.dado_sensivel"></textarea>
      </div>
    </div>

    <div v-if="form.nome_criado_por" class="info row wrap column-s justify-around">
      <div class="text-center grid-6 grid-12-s">
        <label>Criado por</label>
        <div>{{ form.nome_criado_por }} em {{ form.criado_em | date }}</div>
      </div>
      <div class="text-center grid-6 grid-12-s" v-if="form.nome_alterado_por">
        <label>Alterado por</label>
        <div>{{ form.nome_alterado_por }} em {{ form.alterado_em | date }}</div>
      </div>
    </div>

    <div class="controls row justify-center">
      <br /><br />
      <Button v-if="form.cep && form.numero && form.nome_local_atendimento && form.problema" layout="green-go" :loader="loader">{{ form.update ? "ATUALIZAR" : "ADICIONAR"
        }}</Button>&nbsp;&nbsp;&nbsp;
      <Button v-if="form.update && form.status == 'ativo'" type="button" @click="del" :loader="loader"
        layout="red-go"><i class="fa fa-trash" /> DESATIVAR</Button>
      <Button v-if="form.update && form.status == 'inativo'" type="button" @click="updateStatus" :loader="loader"
        layout="green-go white"><i class="fa fa-check" /> ATIVAR</Button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Button from "@/components/Button.vue";
import SelectFilter from "@/components/select/SelectFilter.vue";
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
  name: "JobForm",
  components: { Button, SelectFilter },
  props: { job: Object },
  data() {
    return {
      form: {},
      loader: false,
      chamado_cliente: false,
      logradouro: true,
      estado: true,
      bairro: true,
      cidade: true,
    };
  },
  methods: {
    ...mapActions("general", ["LOAD_CEP"]),
    ...mapActions("admin", ["LOAD_CLIENTS"]),
    ...mapActions("client", ["CLIENT_COD_VERIFY"]),
    ...mapMutations("general", ["SET_STATUS"]),
    escolhaCliente(item) {
      this.form.id_cliente = item.id;
      this.chamado_cliente = item.cod_chamado_cli_obrigatorio
    },
    cep() {
      if (this.form.cep.length > 7) {
        this.logradouro = true;
        this.bairro = true;
        this.estado = true;
        this.cidade = true;
        this.form.logradouro = ''
        this.form.bairro = ''
        this.form.cidade = ''
        this.form.estado = ''
        this.LOAD_CEP(this.form.cep.replace(".", "").replace("-", "")).then((r) => {
          if (r.logradouro) {
            this.form.logradouro = r.logradouro;
            this.form.bairro = r.bairro;
            this.form.cidade = r.localidade;
            this.form.estado = r.uf;
          }

          if (!r.logradouro && r.uf && r.estado) {
            this.SET_STATUS({ text: "O CEP informado resultou um endereço incompleto. Informe o endereço manualmente.", color: "orange" })
            this.form.bairro = r.bairro;
            this.form.cidade = r.localidade;
            this.form.estado = r.uf;
            this.logradouro = false;
            this.bairro = false;
          }

          //15520000
          if (!r.logradouro && !r.uf && !r.estado)
            this.SET_STATUS({
              text: "CEP inválido, clique no link dos Correios para encontrar o CEP correto através do Endereço.",
              color: "red",
            });


        });
      }
    },
    async send() {
      this.loader = true;
      await this.form.send({ ...this.form })
      setTimeout(() => this.loader = false, 1000)
    },
    async updateStatus() {
      this.loader = true;
      this.form.updateStatus(this.form.id)
      this.loader = false;
    },
    del() {
      if (confirm(`Deseja desativar o Supporter ${this.form.nome}?`)) {
        this.loader = true;
        this.form
          .del(this.form)
          .then(() => (this.loader = false))
          .catch(() => (this.loader = false));
      }
    },
    verify_client_cod() {
      this.CLIENT_COD_VERIFY({
        id_client: this.form.id_cliente,
        id_call: this.form.codigo_chamado_cliente,
      }).then((r) => (this.form.codigo_duplicado = r && r.data ? true : false));
    },
  },
  beforeMount() {
    this.form = this.job
    this.LOAD_CLIENTS();
  },
  computed: {
    ...mapGetters("user", ["user", "perfil"]),
    ...mapGetters("admin", ["clients"]),
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.jobForm
  @include form
  margin-top: -5px
  padding: 12px
  select
    width: 93%
    max-width: 93%
  label a
    color: $blue-2
    border-bottom: 1px solid $blue-2
    font-size: 11px
</style>
